export default "__VITE_ASSET__CqQawB4b__"